import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import Axios from "axios";
// import config from '../../config.json' assert { type: 'json' };
// const { onPremURL } = config;
//Enviroment setup. Ideally it should be in .env
// Initialize Sentry
Sentry.init({
  dsn: "https://79b8335d15294c22bf0fb24b89b4202d@o4504854461284352.ingest.sentry.io/4504854463381504",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
});
Axios.defaults.baseURL = process.env.REACT_APP_API_URL
// Axios.defaults.baseURL = 'https://redboard.redlore.com'
// Axios.defaults.baseURL = 'http://172.203.177.199:3000'
// Axios.defaults.baseURL = 'http://localhost:3000'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
